<body class="dashboard dashboard-bg superadmin-dashboard">
  <app-header></app-header>

  <div class="body-container collapsed">
    <app-sidebar></app-sidebar>

    <div class="body-content">
      <div class="row">
        <div class="col p-0">
          <app-page-header title="{{'Data Analysis' | translate}}" iconClass="fas fa-chart-bar"></app-page-header>
        </div>
      </div>

      <app-progress-spinner [show]="isLoading"></app-progress-spinner>

      <div class="white-box">
        <div class="row">
          <div class="col">
            <mat-form-field>
              <mat-label>{{'End Point / Sensor' | translate}}</mat-label>
              <mat-select [(ngModel)]="selected" multiple required>
                <mat-optgroup class="optgroup-label" label="{{'End Points' | translate}}">
                  @for (endPoint of endPoints; track trackByIndex($index)) {
                    <mat-option [value]="endPoint.id">
                      {{endPoint.name}}
                    </mat-option>
                  }
                </mat-optgroup>
                <mat-optgroup class="optgroup-label" label="{{'Sensors' | translate}}">
                  @for (sensor of sensors; track trackByIndex($index)) {
                    <mat-option [value]="sensor.id">
                      {{sensor.name}}
                    </mat-option>
                  }
                </mat-optgroup>
              </mat-select>
              <mat-icon matPrefix class="mr-2">
                <i class="fas fa-desktop"></i>
              </mat-icon>
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-broadcast-tower"></i>
              </mat-icon>
              <mat-error>{{'End Point / Sensor is required' | translate}}</mat-error>
            </mat-form-field>
          </div>

          <div class="col">
            <mat-form-field>
              <mat-label>{{'From Date' | translate}}</mat-label>
              <input matInput [(ngModel)]="fromDate" class="clickable" [owlDateTime]="dtStart"
                [owlDateTimeTrigger]="dtStart" required  />
                <mat-icon matPrefix class="clickable mr-3" [owlDateTimeTrigger]="dtStart">
                  <i class="fas fa-calendar-alt"></i>
                </mat-icon>
                <mat-error>{{'From Date is required' | translate}}</mat-error>
                <owl-date-time #dtStart></owl-date-time>
              </mat-form-field>
            </div>

            <div class="col">
              <mat-form-field>
                <mat-label>{{'To Date' | translate}}</mat-label>
                <input matInput [(ngModel)]="toDate" class="clickable" [owlDateTime]="dtEnd"
                  [owlDateTimeTrigger]="dtEnd" required  />
                  <mat-icon matPrefix class="clickable mr-3" [owlDateTimeTrigger]="dtEnd">
                    <i class="fas fa-calendar-alt"></i>
                  </mat-icon>
                  <mat-error>{{'To Date is required' | translate}}</mat-error>
                  <owl-date-time #dtEnd></owl-date-time>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <mat-form-field>
                  <mat-label>{{'Plot Parameter(s)' | translate}}</mat-label>
                  <mat-select [(ngModel)]="selectedParams" multiple required>
                    @for (param of parameters; track trackByIndex($index)) {
                      <mat-option [value]="param.id">
                        {{param.value}}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-icon matPrefix class="mr-3">
                    <i class="fas fa-chart-line"></i>
                  </mat-icon>
                  <mat-error>{{'Plot Parameter is required' | translate}}</mat-error>
                </mat-form-field>
              </div>

              <div class="col">
                <mat-form-field>
                  <mat-label>{{'Averaging' | translate}}</mat-label>
                  <mat-select [(ngModel)]="timeIntervalId" required>
                    @for (timeInterval of timeIntervals; track trackByIndex($index)) {
                      <mat-option [value]="timeInterval.id"
                        (click)="selectInterval(timeInterval.id)">
                        {{timeInterval.value}}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-icon matPrefix class="mr-3">
                    <i class="fas fa-clock"></i>
                  </mat-icon>
                  <mat-error>{{'Averaging is required' | translate}}</mat-error>
                </mat-form-field>
              </div>

              <div class="col">
                <button mat-button class="btn button-secondary mt-3" (click)="search()"
                  [class.button-spinner]="isLoading" [disabled]="isLoading || isDisabled()">
                  {{'Plot' | translate}}
                </button>

                <button mat-button class="btn button-primary-light mt-3 ml-2 mb-3" (click)="export()"
                  [class.button-spinner]="isLoading" [disabled]="isLoading || isDisabled()">
                  {{'Export Data' | translate}}
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-9" (resized)="onResized($event)">
                <div [id]="CHART_DIV_ID" style="width: 100%; height: 800px;"></div>
              </div>

              <div class="col-lg-3">
                <table class="table">
                  <thead>
                    <tr>
                      <th></th>
                      @for (param of columnParameters; track trackByIndex($index)) {
                        <th>{{param | mapLookup: paramNamesById}}</th>
                        <th></th>
                      }
                    </tr>
                    <tr>
                      <th>{{'End Point / Sensor' | translate}}</th>
                      @for (param of columnParameters; track trackByIndex($index)) {
                        <th>{{'Average' | translate}} [{{param | mapLookup: paramUnitsById}}]</th>
                        <th>{{'Peak' | translate}} [{{param | mapLookup: paramUnitsById}}]</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (device of rowDevices; track trackByIndex($index)) {
                      <tr>
                        <td>{{device}}</td>
                        @for (param of columnParameters; track trackByIndex($index)) {
                          <td>{{$safeNavigationMigration(deviceAverages[device]?.[param]) | number:'1.0-2'}}</td>
                          <td>{{$safeNavigationMigration(devicePeaks[device]?.[param]) | number:'1.0-2'}}</td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-3 offset-lg-9">
              <mat-form-field>
                <mat-label>{{'Time Zone' | translate}}</mat-label>
                <input matInput [(ngModel)]="timeZoneLabel" readonly />
                <mat-icon matPrefix class="mr-3">
                  <i class="fas fa-globe"></i>
                </mat-icon>
              </mat-form-field>
            </div>
          </div>

          <div class="clearfix"></div>
          <app-footer></app-footer>
        </div>

        <div class="clearfix"></div>
      </div>
    </body>
